export default __webpack_public_path__ + "locales/fi/Webhooks.json?hash=06c96381937d7efb2c5b4b8e68d858d1";